// ESM-Huelle fuer lib/scripts/CLS_CComponentBuilder.js (ESM-Welle 5b).
// Originalquelltext unveraendert uebernommen; nur Import/Export sind neu.
// Prototype-Stil bleibt - class-Migration ist ein separater Schritt.

function CComponentBuilder(component, id, addclass)
{
    this.component = component;
    this.id = id;
    this.collector = false;
    if (!(addclass)){
        this.addclass="";
    }
    this.addclass= addclass;
}

CComponentBuilder.prototype.addElement = function(type, properties)
{
    var element = document.createElement(type);

    if(properties)
    {
       /*if((typeof properties.events != "undefined") && (properties.events.onMousedown)){
                var addOnclickEvent = function(el,parameters, me, clickfunc) {
                                el.addEventListener("click", function(e) {
                                        if (e.toElement.tagName == "P"){
                                                clickfunc(e.toElement.parentElement,"onMousedown");
                                        } else {
                                                clickfunc(e.toElement,"onMousedown");
                                        }
                                },false);
                }
                addOnclickEvent(element, null, null, POS.events.eventTrigger);

	}*/

 	if(typeof properties.events != "undefined"){
	    for (var event in properties.events){
		if (properties.events[event]){//  && !(event.startsWith("onMouse"))){
				var trigger = event.substr(2).toLowerCase();;
        			element.addEventListener(trigger, function(e) {
						var s = e.type;
						var event = "on"+s[0].toUpperCase() + s.slice(1);
		 POS.events.eventTrigger(e.currentTarget,event);
					
/*if (e.srcElement.tagName == "P" || e.srcElement.tagName == "IMG" ){
						if (e.toElement && e.toElement.parentElement)
							 POS.events.eventTrigger(e.toElement.parentElement,event);
					} else { 
                                                POS.events.eventTrigger(e.srcElement,event);
					}*/
        			},false);
		}
	    }
	}
/*if (element.tagName == "INPUT"){
 el--´´ement.onfocus= function(e){
	POS.gotFocuse(srcElement.id);
	}


//}*/

        if(typeof properties.attributes != "undefined")
            for(var n in properties.attributes)
                element.setAttribute(n, properties.attributes[n]);

        // ESM-Welle 5b: Waechter auf "object" statt nur auf != undefined.
        // properties.styles ist bei etlichen Komponenten ein STRING (ein
        // Whitespace-<styles> in der XML wird von CXmlHandler.getObject zu
        // textContent; siehe core/xmlhandler.js). "for in" ueber einen String
        // liefert dessen INDIZES, und element.style["0"] = "\n" ist bei
        // CSSStyleDeclaration nicht zugelassen: im Sloppy-Mode still
        // verworfen, im Modul (strict) TypeError ("Indexed property setter
        // is not supported"). Fuer jedes Primitive war die Schleife also
        // schon immer wirkungslos - sie zu ueberspringen ist wertgleich.
        if(typeof properties.styles == "object" && properties.styles != null)
            for(var u in properties.styles)
                element.style[u] = properties.styles[u];

	if(typeof properties.class != "undefined" && properties.class != null)
            this.addclass=properties.class;


        if(typeof properties.value != "undefined" && properties.value != null)
        {
            var value = String(properties.value);

            if (value.search(/\%.*\.{1}.*\%/) != -1)
            {
                value = value.replace(/\%/g, "").split(".");
                value = POS.lang.getText(value[0], value[1]);
            }
            
            element.innerHTML = value;
        }
    }
  if (!(this.addclass)){
        this.addclass="";
    } else{
 	this.addclass=" "+this.addclass;
    }
    element.setAttribute("id", this.id);
    var name= this.component.name +":"+this.id;
    element.setAttribute("name",name);
	var buttonclass ="";
    if  (this.component.name == "CCaption"){
		buttonclass=" "+value;
    }
    element.setAttribute("class", this.component.name + this.addclass + buttonclass);

	//this.component.addEvents(element);    
    this.doAddElement (element);
}

CComponentBuilder.prototype.doAddElement = function(element)
{
    var id = this.id.toString().split(":");
    id.pop();

    if(id.length > 0 && !this.collector)
    {
        POS.getComponentById(id).builder.mainElement.appendChild(element);
        this.component.transmitted = true;
    }
    else
    {
        this.transmitDocument = document.createElement("span");
        this.transmitDocument.appendChild(element);
    }

    this.mainElement = element;
}

CComponentBuilder.prototype.build = function()
{
    var id = this.id.toString().split(":");

    if(id.length == 1)
    {
        if (id[0].split(".")[0] == "template")
        {
            document.getElementById("template").
                appendChild(this.transmitDocument.firstChild);
        }
        else
        {
            document.getElementById("applicationArea").
                appendChild(this.transmitDocument.firstChild);
        }
    }
    else
        document.getElementById(POS.tools.parseParentId(id)).
            appendChild(this.transmitDocument.firstChild);
}

export { CComponentBuilder };
